export default __webpack_public_path__ + "static/media/wuzi__ad.54fdad4c.jpg";